//UserSessionInfo.js
import { ApiMsg } from "./AppConst";
import SessionUserVo from "./SessionUserVo";

export default class UserSessionInfo {
    sessionChecked = false;
    signedIn = false;

    //user = new SessionUserVo();

    constructor(sessionChecked) {
        this.sessionChecked = Boolean(sessionChecked);
        this.signedIn = false;
        this.user = new SessionUserVo();
    }

    static initFromUserObject = (userObj) => {
        const suvo = SessionUserVo.initFromObject(userObj);
        const sessionInfo = new UserSessionInfo(true);
        sessionInfo.user = suvo;
        sessionInfo.signedIn = suvo.sessionNote === ApiMsg.OK;
        return sessionInfo;
    };

    emptyUser = () => {
        this.user = new SessionUserVo();
    };

    isEtraceManager = () => this.user.isEtraceManager();
    isAdmin = () => this.user.isAdmin();

    hasMasterPower = () => this.user.hasMasterPower();

    hasHomplusPower = () => this.user.hasHomplusPower();

    isHomeplusUser = () => this.user.isHomeplusUser();

    isStoreUser = () => this.user.isStoreUser();

    isTransCompanyUser = () => this.user.isTransCompanyUser();

    isDriver = () => this.user.isDriver();

    hasRealUserLoggedIn = () => this.user.hasRealUserLoggedIn();

    isHomeplusOrEtrace = () => this.user.isHomeplusOrEtrace();
    /**
     * 주어진 프로세스에 대한 실행 권한이 있는지 확인한다.
     * @param {object} authNode a node of authTableTreeRepo. tre[procName]
     */
    checkAuth = (authNode) => {
        if(authNode && authNode.allow) {
            return authNode.allow.includes(this.user.authClassInt);
        }
        return false;
    };

    ifLocal = (callback) => {
        let isLocal = window.location.href.includes('//localhost');
        /* if(!isLocal) {
            isLocal = this.user.classNo <= UserClass.EtraceStaff.classNo;
        } */
        if(isLocal) callback(this);
    };
}
